<template>
	<div class="arp-selecao-itens-pedido">
		<az-back-button
			id="azBackButton"
			text="voltar para listagem"
			:route="{ name: rotaGestaoPedidoListagem, params: parametrosGestaoPedidoListagem }"
		></az-back-button>
		<az-container>
			<cabecalho-pagina>
				<template #dataCadastro_editando="{ texto }">
					<v-list-item-subtitle id="subtitulo" class="subtitulo-texto-cabecalho-selecao-pedido">
						<texto-tooltip
							class="white--text"
							:texto="texto.subtitulo.texto"
							:texto-tooltip="informacoesPedido.nomeUsuario"
							:tamanho-maximo="40"
						>
						</texto-tooltip>
					</v-list-item-subtitle>
				</template>
				<template #numero_editando>
					<v-list-item-subtitle id="subtitulo" class="white--text subtitulo-texto-cabecalho-selecao-pedido">
						<texto-tooltip
							:tamanho-maximo="25"
							:texto="numeroPedido | numeroAtaFilter(numeroDoPedidoIsManual)"
						></texto-tooltip>
					</v-list-item-subtitle>
				</template>
			</cabecalho-pagina>
			<div class="az-back-button az-back-button__right">
				<v-btn v-if="isEditar" color="primary" text depressed @click="acessarPedido">
					voltar para o pedido
					<v-icon>mdi-chevron-right</v-icon>
				</v-btn>
			</div>
			<div class="arp-selecao-itens-pedido-cabecalho d-flex justify-sm-space-between">
				<div class="arp-selecao-itens-pedido-cabecalho-titulo">
					<h1>Lista de Itens da Ata</h1>
				</div>
				<div>
					<az-search
						:filter="filtro"
						simple-search-placeholder="Busque por: tipo ou descrição"
						@simple-search="buscarFiltro"
						ref="componenteAzSearch"
						@remove-filter="removerFiltros"
					>
					</az-search>
				</div>
			</div>
			<div class="arp-selecao-itens-pedido__listagem">
				<v-row>
					<v-col cols="12" sm="12" class="flex-column d-flex justify-sm-start">
						<selecao-itens-listagem
							:total-paginas="listagem.totalPaginas"
							:total-itens="listagem.totalItens"
							:paginacao="listagem.paginacao"
							:itens="listagem.datasource"
							@paginar="paginarListagem"
							@resetar-page="resetarPaginaListagem"
							@salvar-item="eventSalvar"
						></selecao-itens-listagem>
					</v-col>
				</v-row>
			</div>
			<v-divider></v-divider>
			<div class="arp-selecao-itens-pedido__rodape">
				<v-row>
					<v-col cols="12" class="flex-column d-flex justify-sm-start">
						<botao-cancelar-confirmar
							:acao-confirmar="salvar"
							:acao-cancelar="cancelar"
							:nome-botao-confirmar="'SALVAR'"
							:is-confirmar-visivel="podeSalvarPedido"
							v-az-auth="permissoes.pedidoUtilizacaoEditar"
						></botao-cancelar-confirmar>
					</v-col>
				</v-row>
			</div>
		</az-container>
	</div>
</template>
<script>
import { actionTypes, mutationTypes, routesNames } from '@/core/constants'
import { mapState } from 'vuex'
import SelecaoItensListagem from '@/views/pages/pedido/selecao-itens/listagem/SelecaoItensPedidoListagem.vue'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import CabecalhoPagina from '@/views/components/CabecalhoPagina.vue'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import cabecalhoPedido from '@/views/mixins/cabecalhoPedido'
import deslogarOrgao from '@/views/mixins/deslogarOrgao'
import tipoAcesso from '@/core/constants/tipo-acesso'
import SalvarItensEmRascunhoPedidoInput from '@/core/apiclient/pedido/models/SalvarItensEmRascunhoPedidoInput'
import RemoverItensEmRascunhoPedidoInput from '@/core/apiclient/pedido/models/RemoverItensEmRascunhoPedidoInput'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import SalvarItemDisponivelQuantidadePedidoInput from '@/core/apiclient/item-pedido/models/SalvarItemDisponivelQuantidadePedidoInput'
import { LoadingScreen } from '@/core/utils'

export default {
	name: 'selecao-itens-pedido',
	components: { TextoTooltip, CabecalhoPagina, SelecaoItensListagem },
	mixins: [validacaoPedido, cabecalhoPedido, deslogarOrgao],
	data() {
		return {
			idAta: null,
			listagem: {
				totalItens: 0,
				totalPaginas: 0,
				paginacao: PaginacaoListagem(['seq']),
				datasource: [],
				estaSalvando: false,
			},
			idPedido: this.$route.params.id,
			isEditar: this.$route.params.tipoAcesso === tipoAcesso.SELECAO_ITEM_PEDIDO.EDITAR,
			salvarTimeout: [],
			timeoutAutosave: 1500,
			loading: new LoadingScreen(this.$store),
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.itemPedido.filtro,
		}),
		parametrosGestaoPedidoListagem() {
			return { id: this.idAta, tipoAcesso: tipoAcesso.PEDIDO.EDITAR }
		},
		rotaGestaoPedidoListagem() {
			return routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW
		},
		temItensPreenchidos() {
			return this.listagem.datasource.filter((item) => item.quantidadeSolicitada > 0).length > 0
		},
		podeSalvarPedido() {
			return (
				this.estaEmElaboracao(this.informacoesPedido) ||
				(this.estaEmRascunho(this.informacoesPedido) && this.temItensPreenchidos)
			)
		},
		numeroPedido: {
			get() {
				if (this.informacoesPedido) return this.informacoesPedido.numeroPedido
				return ''
			},
		},
	},
	async mounted() {
		await this.inicializarComponente()
	},
	beforeDestroy() {
		this.resetarPaginaListagem()
		this.$store.commit(mutationTypes.ITEM_PEDIDO.RESET_FILTRO_LISTAGEM)
		this.$store.commit(mutationTypes.ITEM_PEDIDO.RESET_ITENS_SELECIONADOS)
		this.$store.commit(mutationTypes.PEDIDO.RESET_INFORMACOES)
		this.$store.commit(mutationTypes.LOKI.RESET_AUTO_SAVE)
	},
	methods: {
		async inicializarComponente() {
			this.limparStates()
			await this.carregarCabecalho()
			await this.buscarItensAta()
			this.situacaoPedido = this.informacoesPedido.situacao
			this.mostrarNotificacaoSucesso('Itens da ata carregados com sucesso!')
		},
		async eventSalvar(item) {
			clearTimeout(this.salvarTimeout[item.idItemAta])
			this.removerTimeout(item.idItemAta)
			const evento = async function (item) {
				await this.salvarItem(item)
			}.bind(this)
			this.salvarTimeout[item.idItemAta] = setTimeout(evento, this.timeoutAutosave, item)
		},
		removerTimeout(index) {
			this.salvarTimeout.splice(index, 1)
		},
		async salvarItem(item) {
			if (this.podeSalvarItem(item)) {
				try {
					if (item._quantidadeSolicitada >= 0) {
						let retorno = await this.executarSemLoading(() =>
							this.$store.dispatch(
								actionTypes.ITEM_PEDIDO.SALVAR_ITEM_DISPONIVEL_QUANTIDADE,
								new SalvarItemDisponivelQuantidadePedidoInput(
									this.$route.params.id,
									item.idItemAta,
									item._quantidadeSolicitada,
									this.informacoesPedido.idOrgao,
								),
							),
						)

						item.quantidadeSolicitada = item._quantidadeSolicitada
						item.valorTotalItemAta = retorno.valorTotalItemAta
					} else {
						item._quantidadeSolicitada = item.quantidadeSolicitada
					}
					this.removerTimeout(item.idItemAta)
				} catch (e) {
					item._quantidadeSolicitada = item.quantidadeSolicitada
					this.removerTimeout(item.idItemAta)
				}
			}
		},
		temTimeout() {
			return (
				this.salvarTimeout.filter((item) => {
					return item > 0
				}).length > 0
			)
		},
		podeSalvarItem(item) {
			return (
				(item._quantidadeSolicitada &&
					item._quantidadeSolicitada > 0 &&
					item.quantidadeSolicitada !== item._quantidadeSolicitada) ||
				(item.quantidadeSolicitada > 0 && (!item._quantidadeSolicitada || item._quantidadeSolicitada == 0))
			)
		},
		async buscarItensAta() {
			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_PEDIDO.BUSCAR_ITENS_DISPONIVEIS,
				{ filtro: this.filtro, paginacao: this.listagem.paginacao, idPedido: this.idPedido },
			)

			this.listagem.datasource = this.getItensListagem(itens)
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
		},
		async buscarFiltro(searchText) {
			if (searchText) this.filtro.tipoOuDescricao.value = searchText
			this.resetarPaginaListagem()
			await this.buscarItensAta()
		},
		async removerFiltros() {
			if (this.filtro.tipoOuDescricao.value) {
				this.filtro.tipoOuDescricao.value = this.filtro.tipoOuDescricao.default
			}
			await this.buscarItensAta()
		},
		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms))
		},
		async salvar() {
			await this.temSalvamentoPendente()

			if (this.temItensPreenchidos) {
				await this.salvarPedidoComItensEmRascunho()
			}

			await this.acessarPedido()
		},
		async temSalvamentoPendente() {
			this.loading.start()
			let contTimeout = 0
			while (contTimeout <= 5 && this.temTimeout()) {
				await this.sleep(500)
				contTimeout++
			}

			this.loading.stop()
		},
		async cancelar() {
			if (this.temItensPreenchidos) {
				await this.removerPedidoComItensEmRascunho()
				await this.buscarItensAta()
			}
		},
		async salvarPedidoComItensEmRascunho() {
			await this.$store.dispatch(
				actionTypes.PEDIDO.SALVAR_ITENS_EM_RASCUNHO,
				new SalvarItensEmRascunhoPedidoInput(this.idPedido),
			)
		},
		async removerPedidoComItensEmRascunho() {
			await this.$store.dispatch(
				actionTypes.PEDIDO.REMOVER_ITENS_EM_RASCUNHO,
				new RemoverItensEmRascunhoPedidoInput(this.idPedido),
			)
		},
		async acessarPedido() {
			await this.$router.push({
				name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW,
				params: { id: this.idPedido, tipoAcesso: tipoAcesso.PEDIDO.EDITAR },
			})
		},
		async paginarListagem(paginacao) {
			this.setPaginacaoItensAtaListagem(paginacao)
			await this.buscarItensAta()
		},
		limparStates() {
			this.$store.commit(mutationTypes.PEDIDO.RESET_INFORMACOES)
		},
		setPaginacaoItensAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ITEM_PEDIDO.RESETAR_PAGINA_LISTAGEM)
		},
		getItensListagem(itens) {
			return itens.map((item) => {
				item._quantidadeSolicitada = item.quantidadeSolicitada
				return item
			})
		},
	},
}
</script>
<style scoped lang="stylus">
.az-back-button
	margin-left: 12px
	top: 10px
	position: relative
	font-weight: bold
	font-size: 14px

	.v-btn
		padding: 0
		margin: 0
		height: 20px
		text-transform: lowercase !important

.az-back-button__right
	text-align: end !important

.subtitulo-texto-cabecalho-selecao-pedido
	font-size .80em
</style>
